import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context'; // Import the authentication hook
import './OrderVerification.css'; // Import styles for orders and cards
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const OrderVerification = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const auth = useAuth();




  // Fetch orders from the backend
  useEffect(() => {
    const fetchOrders = async () => {
      if (auth.isAuthenticated && auth.user?.access_token) {
        try {
          const response = await fetch('https://api.currentix.de/api/clientorder', {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${auth.user.access_token}`,  // Attach the token here
            },
          });

          if (response.ok) {
            const data = await response.json();
            setOrders(data.orders);
          } else {
            throw new Error('Failed to fetch orders');
          }
        } catch (err) {
          setError(err.message);
        }
      }
    };

    fetchOrders();
  }, [auth]);

  return (
    <div className="orders">
    <h1>Orders</h1>
    {error && <p>Error: {error}</p>}
    {orders.length === 0 ? (
        <p>No orders available</p>
    ) : (
        <div className="orders-container">
        {orders.map((order) => (
            <OrderCard
            key={order.idOrder}
            order={order}
            setOrders={setOrders}
            />
        ))}
        </div>
    )}
    </div>
  );
};

  const OrderCard = ({ order, setOrders }) => {
  const auth = useAuth();
  const [expanded, setExpanded] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [error, setError] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);  // For controlling dropdown visibility
  const [status, setStatus] = useState(order.status);  // To store the current status
  const navigate = useNavigate();

  // Fetch appointments for the specific order
  const fetchAppointments = async () => {
    try {
      const response = await fetch(`https://api.currentix.de/api/appointments/${order.idOrder}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth.user.access_token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setAppointments(data.appointments);
      } else {
        throw new Error('Failed to fetch appointments');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  // Expand the card to show more details
  const handleExpand = async () => {
    setExpanded(!expanded);
    if (!expanded) {
      await fetchAppointments(); // Fetch appointments when the card is expanded
    }
  };

    // Handle status change and send update to the backend
    const handleStatusChange = async (newStatus) => {
        try {
          const response = await fetch(`https://api.currentix.de/api/clientorder/${order.idOrder}/status`, {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${auth.user.access_token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ status: newStatus }),  // Send updated status
          });
    
          if (response.ok) {
            const updatedOrder = await response.json();
            setStatus(updatedOrder.status); // Update the status in the local state
            setOrders((prevOrders) =>
              prevOrders.map((o) =>
                o.idOrder === order.idOrder ? { ...o, status: updatedOrder.status } : o
              )
            );
          } else {
            throw new Error('Failed to update status');
          }
        } catch (err) {
          setError(err.message);
        }
      };

  return (
    <div className="order-card">
      <div className="card-header" onClick={handleExpand}>
          <h4>
              {order.workDescription.split('<br>').map((line, index) => (
                  <span key={index}>
                      {line}
                      <br />
                  </span>
              ))}
          </h4>
          <p>{new Date(order.orderDate).toLocaleString()}</p>
      </div>

    {expanded && (
        <div className="card-details">
        <div className="order-info">
            <div className="status-container">
              <button onClick={() => setIsDropdownOpen(!isDropdownOpen)}>{status}</button>
              {isDropdownOpen && (
                <div className="status-dropdown">
                  {['open', 'confirmed', 'cancelled', 'complete'].map((option) => (
                    <div
                      key={option}
                      onClick={() => {
                        handleStatusChange(option);
                        setIsDropdownOpen(false);
                      }}
                      className="dropdown-option"
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <p><strong>Total Amount:</strong> ${!isNaN(Number(order.totalAmount)) ? Number(order.totalAmount).toFixed(2) : 'N/A'}</p>
            <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
            <p><strong>Start Date:</strong> {order.startDate}</p>
            <p><strong>End Date:</strong> {order.endDate}</p>
            <p><strong>Address:</strong> {order.address}</p>
            <p><strong>Client:</strong> {order.name} {order.lastname}</p>
            <p><strong>Phone:</strong> {order.phone}</p>
            <p><strong>Email:</strong> {order.email}</p>
            <p><strong>Comment:</strong> {order.comment}</p>
            <button 
            className="details-button"
            onClick={() => navigate(`/order-details/${order.idOrder}`)} // Navigate to order-details page
            >
              View Details
            </button>
        </div>

        <h5>Appointments</h5>
        {error && <p>Error: {error}</p>}
        {appointments.length === 0 ? (
            <p>No appointments available</p>
        ) : (
        <div className="appointments-container">
          {appointments.map((appointment) => (
            <div key={appointment.idAppointment} className="appointment-item">
              <p><strong>Work Description:</strong></p>
                <p>
                    {appointment.workDescription.split('<br>').map((line, index) => (
                        <span key={index}>
                            {line}
                            <br />
                            </span>
                    ))}
                </p>
                <p><strong>Appointment Start:</strong> {new Date(appointment.appointmentStart).toLocaleString()}</p>
                <p><strong>Location:</strong> {appointment.location}</p>
                <p><strong>Status:</strong> {appointment.status}</p>
              </div>
            ))}
          </div>
        )}
        </div>
    )}
    </div>
  );
}; 


export default OrderVerification;
